import React from "react";
import { DataObject } from "@mui/icons-material";
import { Box, Chip, Stack, Typography } from "@mui/material";
import { RegistryVariable } from "../../registry/sitePageRegistry";

interface VariableChipsProps {
  variables: RegistryVariable[];
  onInsert: (variable: RegistryVariable) => void;
}

const VariableChips: React.FC<VariableChipsProps> = ({ variables, onInsert }) => (
  <Box>
    <Stack direction="row" alignItems="center" spacing={0.75} sx={{ mb: 0.75 }}>
      <DataObject fontSize="inherit" color="action" />
      <Typography variant="caption" color="text.secondary">Insert variable</Typography>
    </Stack>
    <Stack direction="row" spacing={0.75} useFlexGap flexWrap="wrap">
      {variables.map((variable) => (
        <Chip
          key={variable.key}
          size="small"
          label={variable.label}
          variant="outlined"
          // mousedown (not click) + preventDefault keeps the caret/selection
          // inside the editable field intact so the token lands where expected.
          onMouseDown={(event) => {
            event.preventDefault();
            onInsert(variable);
          }}
        />
      ))}
    </Stack>
  </Box>
);

export default VariableChips;
